import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Input } from '@angular/core';

@Component({
    selector: 'elem-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TooltipComponent {

    @Input()
    text: string;

    /** true, wenn per Klick fixiert (bleibt offen bis Außenklick / erneuter Klick) */
    pinned = false;

    /** true, wenn aktuell mit der Maus gehovert wird */
    hovered = false;

    constructor(private readonly elementRef: ElementRef) {
    }

    get visible(): boolean {
        return this.pinned || this.hovered;
    }

    onMouseEnter(): void {
        this.hovered = true;
    }

    onMouseLeave(): void {
        this.hovered = false;
    }

    toggle(event: Event): void {
        event.stopPropagation();
        this.pinned = !this.pinned;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event): void {
        if (this.pinned && !this.elementRef.nativeElement.contains(event.target)) {
            this.pinned = false;
        }
    }

    @HostListener('document:keydown.escape')
    onEscape(): void {
        this.pinned = false;
    }

}
